import React, { useEffect, useState } from "react";
import { Tab } from "@mui/material";
import { TabType } from "../shared/enums";
import { ManagementTab } from "../user-order-management/blocks/user-management-view/customer-view";
import {
  SettingsContainer,
  SettingsTabContainer,
  UserTabs,
} from "../../pages/user/settings/styled";
import { ActionBar } from "../../pages/components/action-bar/action-bar";
import {
  Message,
  MessageSections,
} from "../../pages/components/message/message";
import {
  actionsColumn,
  cityProvince,
  productCategoryDescriptionColumn,
  provinceCountry,
  regionCity,
  staticDataJsonNameColumn,
  staticDataNameColumn,
  staticDataTitleColumn,
  storesStatusColumn,
} from "../shared/model/customers-table-column.model";
import productStoresService from "../../services/product-stores.service";
import regionService from "../../services/region-service";
import blogService from "../../services/blog-service";
import provinceService from "../../services/province-service";
import cityService from "../../services/city-service";
import productCategoriesService from "../../services/product-categories.service";
import {
  ManagementDataContainer,
  ManagementPageType,
} from "../user-order-management/management-data-container";
/*import {
  InWarehouseActionTypes,
  OrderPopupActionTypes,
  ReadyForShipmentActionTypes,
} from "../actions/action-types.enum";*/
import { ActionDialog } from "../actions/dialogs/action-dialog";
import {
  getCities,
  getProvinces,
  getRegions,
} from "../../redux/slices/static-data.slice";
import { useAppDispatch } from "../../redux/store";
import { StaticDataManagementActions } from "../actions/actions-by-state";
import onlineStoresService from "../../services/online-stores-service";
import onlineStoryCategoryService from "../../services/online-story-category-service";
import blogCategoryService from "../../services/blog-category-service";

export const StaticDataManagement = () => {
  const [isReady, setIsReady] = useState(false);
  const [activeAction, setActiveAction] = useState<string>();

  const [tabs, setTabs] = useState([] as ManagementTab[]);
  const [tab, setTab] = useState<ManagementTab | undefined>(undefined);

  const dispatch = useAppDispatch();

  useEffect(() => {
    const staticDataTabs = [
      {
        type: TabType.STORE,
        messageKey: "stores",
        uniqueKey: "stores.0",
        component: (
          <ManagementDataContainer
            key={TabType.STORE}
            columns={[
              staticDataJsonNameColumn,
              storesStatusColumn,
              actionsColumn,
            ]}
            defaultFilter={{}}
            type={ManagementPageType.STATIC_VALUES}
            staticDataType={TabType.STORE}
            searchFunction={productStoresService.getProductStores}
          />
        ),
      },
      {
        type: TabType.PRODUCT_CATEGORY,
        messageKey: "product_categories",
        uniqueKey: "productCategories.0",
        component: (
          <ManagementDataContainer
            key={TabType.PRODUCT_CATEGORY}
            columns={[
              staticDataJsonNameColumn,
              productCategoryDescriptionColumn,
              actionsColumn,
            ]}
            defaultFilter={{}}
            type={ManagementPageType.STATIC_VALUES}
            staticDataType={TabType.PRODUCT_CATEGORY}
            searchFunction={productCategoriesService.getProductCategories}
          />
        ),
      },
      {
        type: TabType.PROVINCE,
        messageKey: "provinces",
        uniqueKey: "provinces.0",
        component: (
          <ManagementDataContainer
            key={TabType.PROVINCE}
            columns={[staticDataJsonNameColumn, provinceCountry, actionsColumn]}
            defaultFilter={{}}
            type={ManagementPageType.STATIC_VALUES}
            staticDataType={TabType.PROVINCE}
            searchFunction={provinceService.getProvinces}
          />
        ),
      },
      {
        type: TabType.CITY,
        messageKey: "cities",
        uniqueKey: "cities.0",
        component: (
          <ManagementDataContainer
            key={TabType.CITY}
            columns={[staticDataJsonNameColumn, cityProvince, actionsColumn]}
            defaultFilter={{}}
            type={ManagementPageType.STATIC_VALUES}
            staticDataType={TabType.CITY}
            searchFunction={cityService.getCities}
          />
        ),
      },
      {
        type: TabType.REGION,
        messageKey: "regions",
        uniqueKey: "regions.0",
        component: (
          <ManagementDataContainer
            key={TabType.REGION}
            columns={[staticDataJsonNameColumn, regionCity, actionsColumn]}
            defaultFilter={{}}
            type={ManagementPageType.STATIC_VALUES}
            staticDataType={TabType.REGION}
            searchFunction={regionService.getRegions}
          />
        ),
      },
      {
        type: TabType.BLOG,
        messageKey: "blog",
        uniqueKey: "blog.0",
        component: (
          <ManagementDataContainer
            key={TabType.BLOG}
            columns={[staticDataTitleColumn, actionsColumn]}
            defaultFilter={{}}
            type={ManagementPageType.STATIC_VALUES}
            staticDataType={TabType.BLOG}
            searchFunction={blogService.getPosts}
          />
        ),
      },
      {
        type: TabType.BLOG_CATEGORY,
        messageKey: "blog_category",
        uniqueKey: "blog_category.0",
        component: (
          <ManagementDataContainer
            key={TabType.BLOG_CATEGORY}
            columns={[staticDataJsonNameColumn, actionsColumn]}
            defaultFilter={{}}
            type={ManagementPageType.STATIC_VALUES}
            staticDataType={TabType.BLOG_CATEGORY}
            searchFunction={blogCategoryService.getBlogCategories}
          />
        ),
      },
      {
        type: TabType.ONLINE_STORES,
        messageKey: "online_stores",
        uniqueKey: "online_stores.0",
        component: (
          <ManagementDataContainer
            key={TabType.ONLINE_STORES}
            columns={[staticDataNameColumn, actionsColumn]}
            defaultFilter={{}}
            type={ManagementPageType.STATIC_VALUES}
            staticDataType={TabType.ONLINE_STORES}
            searchFunction={onlineStoresService.getStores}
          />
        ),
      },
      {
        type: TabType.ONLINE_STORE_CATEGORY,
        messageKey: "online_store_categories",
        uniqueKey: "online_store_categories.0",
        component: (
          <ManagementDataContainer
            key={TabType.ONLINE_STORE_CATEGORY}
            columns={[staticDataJsonNameColumn, actionsColumn]}
            defaultFilter={{}}
            type={ManagementPageType.STATIC_VALUES}
            staticDataType={TabType.ONLINE_STORE_CATEGORY}
            searchFunction={onlineStoryCategoryService.getOnlineStoreCategories}
          />
        ),
      },
    ];
    setTabs(staticDataTabs);
    setTab(staticDataTabs[0]);

    Promise.allSettled([
      dispatch(getProvinces()),
      dispatch(getCities()),
      dispatch(getRegions()),
    ]).then(() => setIsReady(true));
  }, []);

  const handleChange = (selectedType: {
    type: TabType;
    messageKey: string;
    component: JSX.Element;
  }) => {
    setTab(selectedType);
  };

  function onActionClick(actionId: string) {
    setActiveAction(actionId);
  }

  function handleDialogClose() {
    setActiveAction(undefined);

    if (tab) {
      const currentKey = +(tab.uniqueKey ? tab.uniqueKey.split(".")[1] : 1);
      setTab({ ...tab, uniqueKey: "workers." + (currentKey + 1) });

      switch (tab.type) {
        case TabType.PROVINCE:
          dispatch(getProvinces());
          break;
        case TabType.CITY:
          dispatch(getCities());
          break;
      }
    }
  }

  if (isReady) {
    return (
      <SettingsContainer>
        <ActionBar
          actions={
            tab?.type === TabType.STORE ? [] : StaticDataManagementActions
          }
          actionFunction={onActionClick}
          headerText={
            <Message
              messageKey={"static_values"}
              sectionId={MessageSections.MAIN}
            />
          }
        />

        <UserTabs
          value={tab ? tab.type : 0}
          variant={"scrollable"}
          scrollButtons={true}
        >
          {tabs.map((tabInfo) => {
            return (
              <Tab
                value={tabInfo.type}
                key={tabInfo.messageKey}
                label={
                  <Message
                    messageKey={tabInfo.messageKey}
                    sectionId={MessageSections.USER}
                  />
                }
                onClick={() => handleChange(tabInfo)}
              />
            );
          })}
        </UserTabs>

        <SettingsTabContainer key={tab && tab.uniqueKey}>
          {tab ? tab.component : ""}
        </SettingsTabContainer>

        <ActionDialog
          open={!!activeAction}
          action={activeAction}
          staticDataDialogProps={{ type: tab?.type, staticData: {} }}
          closePopup={() => handleDialogClose()}
        />
      </SettingsContainer>
    );
  } else {
    return <></>;
  }
};
